import { IconButton } from '@mui/material';
import type { PlanBillingData, SyncStatus } from '@weft/types';
import React from 'react';
import { useSwallowClick } from '../../../../hooks/use-swallow-click';
import { ContractPageHeaderMenu } from '../../../contract/contract-page-components/ContractPageHeaderMenu/ContractPageHeaderMenu';

type ContractDotMenuProps = {
  contractId: string;
  planId: string;
  planName: string;
  billingData: PlanBillingData;
  isActive: boolean;
  customerName: string;
  isTerminated: boolean;
  syncStatus: SyncStatus;
  contractStartDate: Date;
  contractEndDate?: Date;
};

export const ContractDotMenu:React.FC<ContractDotMenuProps> = ({ contractId, planId, planName, billingData, customerName, isActive, isTerminated, syncStatus, contractStartDate, contractEndDate }) =>{
  const swallowClick = useSwallowClick();

  return (
    <div
      onClick={(event: React.MouseEvent<HTMLDivElement> & { ignore?: boolean }) => {
        event.ignore = true;
      }}
      className="flex justify-center"
    >
      <ContractPageHeaderMenu
        contractId={contractId}
        planId={planId}
        planName={planName}
        billingData={billingData}
        customerName={customerName}
        isActive={isActive}
        isTerminated={isTerminated}
        contractStartDate={contractStartDate}
        contractEndDate={contractEndDate}
        contractName={planName}
        syncStatus={syncStatus}
      >
        <IconButton
          onClick={swallowClick}
          disableRipple
        >
          <span
            className='bg-icon text-label mx-2 mb-[3px] inline-block h-1 w-1 rounded-full shadow-[0_7px_0_#ADC2E2,0_-7px_0_#ADC2E2]'
          ></span>
        </IconButton>
      </ContractPageHeaderMenu>
    </div>
  );
};
